<template>
    <section id="vue-lodging">
        <div class="container">
            <h2>Lodging</h2>
            <hr/>
            <ul class="hotels-list">
                <li>
                    <hotel
                        name="AC Hotel by Marriott"
                        address="401 E Grand Avenue"
                        city="Des Moines"
                        zip="50309"
                        blockLink="http://www.marriott.com/meeting-event-hotels/group-corporate-travel/groupCorp.mi?resLinkData=Vodraska%20%7C%20Foreman%20Wedding%5EDSMAD%60VRWVRWA%7CVRWVRWB%60179.00%60USD%60false%604%609/7/18%609/9/18%6008/10/18&app=resvlink&stop_mobi=yes"
                        url="http://www.marriott.com/meeting-event-hotels/group-corporate-travel/groupCorp.mi?resLinkData=Vodraska%20%7C%20Foreman%20Wedding%5EDSMAD%60VRWVRWA%7CVRWVRWB%60179.00%60USD%60false%604%609/7/18%609/9/18%6008/10/18&app=resvlink&stop_mobi=yes"
                    />
                </li>
                <li>
                    <hotel
                        name="Staybridge Suites"
                        address="201 E Locust Street"
                        city="Des Moines"
                        zip="50301"
                        blockLink="https://www.staybridge.com/redirect?path=hd&brandCode=SB&localeCode=en&regionCode=1&hotelCode=DSMSY&_PMID=99801505&GPC=VFW&viewfullsite=true"
                        url="https://www.staybridge.com/redirect?path=hd&brandCode=SB&localeCode=en&regionCode=1&hotelCode=DSMSY&_PMID=99801505&GPC=VFW&viewfullsite=true"
                    />
                </li>
                <li>
                    <hotel
                        name="Hampton Inn and Suites"
                        address="120 SW Water Street"
                        city="Des Moines"
                        zip="50309"
                        url="http://hamptoninn3.hilton.com/en/hotels/iowa/hampton-inn-and-suites-des-moines-downtown-DSMWSHX/index.html"
                    />
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
import Hotel from '../components/hotel-info.vue';

export default {
    name: 'lodging-view',
    components: {
        'hotel': Hotel
    },
    data: () => ({})
};
</script>



// WEBPACK FOOTER //
// src/views/lodging.vue?653929d6